import { useState, useEffect } from "react";
import DownloadButton from "../../../../assets/icons/maid-module-icons/downloadButton.svg";
import FilterIcon from "../../../../assets/icons/maid-module-icons/FilterIcon.svg";
import CrossIcon from "../../../../assets/icons/maid-module-icons/CrossIcon.svg";
import In from "../../../../assets/icons/maid-module-icons/In.svg";
import Out from "../../../../assets/icons/maid-module-icons/Out.svg";
import { commonAPI } from "../../../../services/CommonAPIService";
import FilterModal from "./FilterModal";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { toast } from "react-toastify";
import curonext from "../../../../assets/img/CuronextFinal.png"; 

const formatDt = (isoStr) => {
  if (!isoStr) return "—";
  const d = new Date(isoStr);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const TransitReport = ({ showTransit, setShowTransit,roleId,role }) => {
  const [apiData, setApiData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeStartDt, setActiveStartDt] = useState(new Date().toISOString());
  const [userData, setUserData] = useState(null);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
 

  console.log("Api data is ",apiData)

const fetchTransitLogDetail = async (payload) => {
  const auth = localStorage.getItem("userData");
  if (!auth) return;

  const myUserData = JSON.parse(auth);
  setUserData(myUserData);
  setLoading(true);

  let finalPayload = null;

  try {
    finalPayload = {
      ...payload,
      roleId: roleId ?? null,
    };

    const response = await commonAPI(
      "TransitLogDetail",
      finalPayload,
      { buildingId: myUserData?.buildingId }
    );

    if (response?.success) {
      setApiData(response.data || null);
    } else {
      throw new Error(response?.message || "Failed to fetch transit log");
    }

  } catch (error) {
    console.error("TransitLogDetail Error:", error);

    const bodyError = {
      userId: myUserData?.userId || null,
      mobileNumber: myUserData?.mobileNumber || null,
      requestJSON: JSON.stringify(finalPayload),
      uri: "/api/User/GetServiceStaffTransitLog",
      errorSource: "CuroNextPortal",
      errorNumber: "TRNSTLG01",
      errorSummary: error?.message,
      errorDescription: JSON.stringify(error),
      fileClassName: "TransitReport.js",
      functionName: "fetchTransitLogDetail",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    toast.error(error?.message || "Error while fetching transit log");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const auth = localStorage.getItem("userData");
    if (auth) setUserData(JSON.parse(auth));
    fetchTransitLogDetail({
      startDt: new Date().toISOString(),
      isCurrentlyIn: null,
    });
  }, [roleId]);

  const handleApplyFilter = (payload) => {
    setActiveStartDt(payload.startDt || new Date().toISOString());
    fetchTransitLogDetail(payload);
  };

  const allTransit = apiData?.allTransit || [];
  const totalCount = apiData?.totalCount ?? allTransit.length;
  const currentlyInCount = apiData?.currentlyInCount ?? allTransit.filter(p => p.isCurrentlyIn).length;

  const displayDate = new Date(activeStartDt).toLocaleDateString("en-IN", {
    day: "2-digit", month: "2-digit", year: "numeric",
  });

  // ─── Excel Export ──────
  const exportToExcel = () => {
    if (allTransit.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const rows = [];
    allTransit.forEach((person) => {
      (person.allTransit || []).forEach((transit, idx) => {
        rows.push({
          "S.No": idx + 1,
          "Name": person.userName || "—",
          "Mobile": person.mobileNumber || "—",
          "Status": person.isCurrentlyIn ? "Currently In" : "Currently Out",
          "Entry Date/Time": formatDt(transit.entryDt),
          "Exit Date/Time": transit.exitDt ? formatDt(transit.exitDt) : "—",
        });
      });
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(rows);

    // Auto column widths
    const colWidths = Object.keys(rows[0] || {}).map((key) => ({
      wch: Math.max(key.length, ...rows.map((r) => String(r[key] || "").length)) + 2,
    }));
    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Transit Report");
    XLSX.writeFile(wb, `Transit_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
    toast.success("Excel exported successfully");
    setShowDownloadMenu(false);
  };

  // ─── PDF Export ────
  const exportToPDF = () => {
    if (allTransit.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    // ── Header ──
    if (userData?.logo) {
      doc.addImage(`data:image/jpeg;base64,${userData.logo}`, "JPEG", 10, 8, 25, 15);
    }
    try {
      doc.addImage(curonext, "PNG", pageWidth - 45, 8, 35, 12);
    } catch (_) {}

    doc.setFontSize(14).setFont("helvetica", "bold");
    doc.text(userData?.buildingName || "Building", pageWidth / 2, 15, { align: "center" });

    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text(
      `${userData?.addressLine1 || ""} ${userData?.addressLine2 || ""}`.trim(),
      pageWidth / 2, 22, { align: "center" }
    );
    doc.text(
      `${userData?.city || ""}, ${userData?.state || ""}`.replace(/^,\s*/, ""),
      pageWidth / 2, 27, { align: "center" }
    );

    doc.setFontSize(16).setFont("helvetica", "bold");
    doc.text("Transit Report", pageWidth / 2, 40, { align: "center" });

    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text(`Date: ${displayDate}`, pageWidth / 2, 48, { align: "center" });

    // Summary line
    doc.setFontSize(10);
    doc.text(`Total Count: ${totalCount}    Currently In: ${currentlyInCount}`, pageWidth / 2, 55, { align: "center" });

    // ── Table ──
    const tableData = [];
    let sno = 1;
    allTransit.forEach((person) => {
      (person.allTransit || []).forEach((transit) => {
        tableData.push([
          sno++,
          person.userName || "—",
          person.mobileNumber || "—",
          person.isCurrentlyIn ? "In" : "Out",
          formatDt(transit.entryDt),
          transit.exitDt ? formatDt(transit.exitDt) : "—",
        ]);
      });
    });

    doc.autoTable({
      head: [["#", "Name", "Mobile", "Status", "Entry Time", "Exit Time"]],
      body: tableData,
      startY: 62,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 3 },
      headStyles: { fillColor: [47, 128, 192], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [239, 246, 255] },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        3: { halign: "center" },
      },
      foot: [["", "", "", "", "", `Total Records: ${tableData.length}`]],
      footStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: "bold" },
    });

    doc.save(`Transit_Report_${new Date().toISOString().slice(0, 10)}.pdf`);
    toast.success("PDF exported successfully");
    setShowDownloadMenu(false);
  };

  return (
    <>
      {showTransit && (
        <div
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
            display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1200,
          }}
          onClick={() => setShowDownloadMenu(false)}
        >
          <div
            style={{
              width: "650px", background: "#fff", borderRadius: "16px",
              overflow: "hidden", maxHeight: "90vh", display: "flex", flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* ── Header ── */}
            <div style={{ background: "#2F80C0", color: "#fff", padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <span style={{ fontSize: "21px", fontWeight: 600 }}>Transit Report</span>
                <span style={{ marginLeft: 8, fontSize: 14 }}>• {displayDate}</span>
                  <div
                    style={{
                      marginTop: 4,
                      fontSize: 16,
                      fontWeight: 500,
                      color: "#fff",
                    }}
                  >
                    {role}
                  </div>
              </div>
              <button
                className="btn p-0 d-flex align-items-center justify-content-center bg-white"
                style={{ width: 24, height: 24, borderRadius: 6 }}
                onClick={() => {
                    setShowTransit(false);
                    
                  }}

              >
                <img src={CrossIcon} alt="close" />
              </button>
            </div>

            {/* ── Action Buttons ── */}
            <div style={{ display: "flex", gap: "16px", padding: "16px 20px" }}>

              {/* Download button with dropdown */}
              <div style={{ flex: 1, position: "relative" }}>
                <button
                  onClick={() => setShowDownloadMenu((prev) => !prev)}
                  style={{
                    width: "100%", padding: "8px", borderRadius: "20px",
                    border: "1px solid #2F80C0", background: "#fff", color: "#2F80C0",
                    cursor: "pointer", display: "flex", alignItems: "center",
                    justifyContent: "center", gap: "6px",
                  }}
                >
                  <img src={DownloadButton} alt="download" />
                  <span style={{ textTransform: "none", fontSize: "15px" }}>Download</span>
                </button>

                {showDownloadMenu && (
                  <div
                    style={{
                      position: "absolute", top: "calc(100% + 6px)", left: 0,
                      background: "#fff", border: "1px solid #dde3ea",
                      borderRadius: 10, boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                      zIndex: 100, minWidth: "180px", overflow: "hidden",
                    }}
                  >
                    <button
                      onClick={exportToPDF}
                      style={{
                        width: "100%", padding: "10px 16px", background: "none",
                        border: "none", textAlign: "left", cursor: "pointer",
                        fontSize: 14, color: "#2F80C0", display: "flex",
                        alignItems: "center", gap: 8,
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#EFF6FF")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
                    >
                     Export as PDF
                    </button>
                    <div style={{ height: 1, background: "#eee" }} />
                    <button
                      onClick={exportToExcel}
                      style={{
                        width: "100%", padding: "10px 16px", background: "none",
                        border: "none", textAlign: "left", cursor: "pointer",
                        fontSize: 14, color: "#2F80C0", display: "flex",
                        alignItems: "center", gap: 8,
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#EFF6FF")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
                    >
                         Export as Excel
                    </button>
                  </div>
                )}
              </div>

              {/* Filter button */}
              <button
                onClick={() => setShowFilter(true)}
                style={{
                  flex: 1, padding: "8px", borderRadius: "20px",
                  border: "1px solid #2F80C0", background: "#fff", color: "#2F80C0",
                  cursor: "pointer", display: "flex", alignItems: "center",
                  justifyContent: "center", gap: "6px",
                }}
              >
                <img src={FilterIcon} alt="filter" />
                <span style={{ textTransform: "none", fontSize: "15px" }}>Filter</span>
              </button>
            </div>

            {/* ── Count Bar ── */}
            <div style={{ height: "60px", background: "#EFF0F1", marginTop: 2, marginBottom: 16, borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", fontWeight: 500 }}>
              <div>Total Count : {totalCount}</div>
              <div>Currently In : {currentlyInCount}</div>
            </div>

            {/* ── Scrollable Body ── */}
            <div style={{ overflowY: "auto", padding: "0 20px 20px 20px" }}>
              {loading ? (
                <div style={{ textAlign: "center", padding: "40px", color: "#777" }}>Loading...</div>
              ) : allTransit.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px", color: "#777" }}>No records found.</div>
              ) : (
                allTransit.map((person, personIndex) => (
                  <div key={personIndex}>

                    {/* User Info */}
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: 12 }}>
                      <img
                        src={person.userImageURL}
                        alt="profile"
                        style={{ width: 42, height: 42, borderRadius: "50%", objectFit: "cover" }}
                      />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 15 }}>{person.userName}</div>
                        <div style={{ fontSize: 13, color: "#777" }}>{person.mobileNumber || "—"}</div>
                      </div>
                      {person.isCurrentlyIn === true ? (
                        <span style={{ marginLeft: "auto", fontSize: 11, fontWeight: 600, color: "#198754", background: "#e8f5e9", borderRadius: 20, padding: "3px 10px" }}>
                          Currently In
                        </span>
                      ) : (
                        <span style={{ marginLeft: "auto", fontSize: 11, fontWeight: 600, color: "#D32F2F", background: "#fdecea", borderRadius: 20, padding: "3px 10px" }}>
                          Currently Out
                        </span>
                      )}
                    </div>

                    {/* Transit Rows */}
                    {(person.allTransit || []).map((transit, transitIndex) => (
                      <div key={transitIndex}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                          <div style={{ flex: "0 0 50%" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 600, fontSize: 14, color: "#111" }}>
                              <img src={In} alt="entry" style={{ width: 14, height: 14 }} />
                              Entry
                            </div>
                            <div style={{ color: "#6B6B6B", fontSize: 12, marginTop: 4 }}>{formatDt(transit.entryDt)}</div>
                          </div>
                          <div style={{ flex: "0 0 50%" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 600, fontSize: 14, color: "#111" }}>
                              <img src={Out} alt="exit" style={{ width: 14, height: 14 }} />
                              Exit
                            </div>
                            <div style={{ color: "#6B6B6B", fontSize: 12, marginTop: 4 }}>
                              {transit.exitDt ? formatDt(transit.exitDt) : "—"}
                            </div>
                          </div>
                        </div>

                        {transitIndex < (person.allTransit.length - 1) && (
                          <div style={{ height: "1px", background: "#D0DCE8", marginBottom: 12, borderRadius: 2 }} />
                        )}
                      </div>
                    ))}

                    <div style={{ height: "6px", background: "#E8EEF5", marginTop: 4, marginBottom: 16, borderRadius: 4 }} />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

         {showTransit && (
        <FilterModal
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          onApply={handleApplyFilter}
        />
      )}
    </>
  );
};

export default TransitReport;